module.exports = __webpack_public_path__ + "img/connections.9f5906b9.svg";